import _ from 'lodash'
import type {DecorationSingleComponentPluginFunction} from '../../types'
import type {ComponentExportStructure, ResolvedDataItem} from '@wix/document-services-types'
import {forEachItemInVariantSplit} from '../../utils/variants'
import {STYLE_PROPERTY_SOURCE, type DecoratedStyleProperty, THEME_VAR_PREFIXES} from './constants'
import {removeEmptyObjects} from '../../utils/dataUtils'

const {THEME, VALUE} = STYLE_PROPERTY_SOURCE

const isThemeRegex = new RegExp(`^${THEME_VAR_PREFIXES.join('|')}_(.+)$`)
const getPropertySource = (value: string) => (isThemeRegex.test(value) ? THEME : VALUE)

const convertStyleProperties = (styleItem: ResolvedDataItem) => {
    const {style} = styleItem
    if (_.isEmpty(style)) {
        return
    }

    const {properties: styleProperties, ...rest} = style
    const properties: Record<string, any> = {}
    const propertiesSource: Record<string, any> = {}
    const propertiesOverride: Record<string, any> = {}

    _.forOwn(styleProperties, ({value, additionalData, overrides}: DecoratedStyleProperty, property: string) => {
        if (value) {
            properties[property] = value
            propertiesSource[property] = getPropertySource(value)
        }

        if (additionalData) {
            _.forOwn(additionalData, (prefixedPropertyValue: string, prefix: string) => {
                const prefixedPropertyKey = `${prefix}-${property}`
                properties[prefixedPropertyKey] = prefixedPropertyValue
                propertiesSource[prefixedPropertyKey] = VALUE
            })
        }

        if (overrides) {
            propertiesOverride[property] = overrides
        }
    })

    styleItem.style = removeEmptyObjects({
        properties,
        propertiesSource,
        propertiesOverride,
        ...rest
    })
}

export const unpack: DecorationSingleComponentPluginFunction = (component: ComponentExportStructure) => {
    forEachItemInVariantSplit(component.style, convertStyleProperties)
}
